"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050store/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _foodVariation = require("@/api/foodVariation");
var _vuex = require("vuex");
var foodApi = _interopRequireWildcard(require("@/api/food"));
var _format = require("@/utils/format");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ["food"],
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["token"])),
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      total: 0,
      form: {},
      foodVariationGroupName: "",
      foodVariations: [],
      fileList: [],
      dialogStatus: "add",
      loading: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      visible: false,
      listQuery: {
        page: 1,
        limit: 50
      },
      rules: {
        name: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập tên gọi"
        },
        price: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập giá"
        }
      }
    };
  },
  watch: {
    food: {
      handler: function handler() {
        console.log("food data", this.food);
        this.foodVariationGroupName = this.food.foodVariationGroupName;
        this.fetchVariations();
      },
      immediate: true
    },
    visible: {
      handler: function handler() {
        this.form = {};
      },
      immediate: true
    }
  },
  methods: {
    formatMoney: function formatMoney(value) {
      return (0, _format.formatCurrency)(value);
    },
    uploadListSuccess: function uploadListSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleError: function handleError(response, file, fileList) {
      var message = JSON.parse(response.message);
      this.$notify.error({
        message: message.message,
        title: "Thông báo"
      });
    },
    handleExceed: function handleExceed(file, fileList) {
      this.$notify.error({
        message: "Số lượng hình đã tối đa. Nếu muốn upload hình mới, vui lòng xoá hình cũ để có thể upload tiếp",
        title: "Thông báo"
      });
    },
    handleAddVariant: function handleAddVariant() {
      var _this = this;
      this.dialogStatus = "add";
      this.visible = true;
      this.$nextTick(function () {
        _this.$refs["form"].resetFields();
        _this.form = {};
      });
    },
    handleUpdateGroupName: function () {
      var _handleUpdateGroupName = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var food;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              food = {
                foodVariationGroupName: this.foodVariationGroupName || ""
              };
              _context.prev = 2;
              _context.next = 5;
              return foodApi.update(this.food.id, {
                food: food
              });
            case 5:
              this.$notify({
                type: "success",
                message: "Đã lưu thay đổi"
              });
              this.$emit("updateSuccess");
            case 7:
              _context.prev = 7;
              this.loading = false;
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2,, 7, 10]]);
      }));
      function handleUpdateGroupName() {
        return _handleUpdateGroupName.apply(this, arguments);
      }
      return handleUpdateGroupName;
    }(),
    fetchVariations: function () {
      var _fetchVariations = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.food.id) {
                _context2.next = 6;
                break;
              }
              _context2.next = 3;
              return (0, _foodVariation.getVariant)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
                foodId: this.food.id
              }));
            case 3:
              res = _context2.sent;
              this.foodVariations = res.data.foodVariations;
              this.total = res.data.total;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchVariations() {
        return _fetchVariations.apply(this, arguments);
      }
      return fetchVariations;
    }(),
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(row) {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.dialogStatus = "edit";
              this.visible = true;
              this.$nextTick(function () {
                _this2.$refs["form"].clearValidate();
                _this2.form = (0, _objectSpread2.default)({}, row);
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(row) {
        var _this3 = this;
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm("Thuộc tính này sẽ bị xoá, Tiếp tục?", "Cảnh báo", {
                confirmButtonText: "Xoá",
                cancelButtonText: "Đóng",
                type: "warning"
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
                return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return (0, _foodVariation.deleteVariant)(row.id);
                    case 2:
                      _this3.$message({
                        type: "success",
                        message: "Đã xoá"
                      });
                      _this3.$emit("updateSuccess");
                      _this3.fetchVariations();
                    case 5:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              })));
              if (!this.food.id) {
                _context5.next = 6;
                break;
              }
              _context5.next = 4;
              return (0, _foodVariation.getVariant)({
                foodId: this.food.id
              });
            case 4:
              res = _context5.sent;
              this.foodVariations = res.data.foodVariations;
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        var _this4 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.$refs["form"].validate(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(valid) {
                  var foodVariation;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!valid) {
                          _context6.next = 12;
                          break;
                        }
                        _this4.loading = true;
                        foodVariation = (0, _objectSpread2.default)({}, _this4.form);
                        _context6.prev = 3;
                        _context6.next = 6;
                        return (0, _foodVariation.postVariant)({
                          foodVariation: foodVariation,
                          foodId: _this4.food.id
                        });
                      case 6:
                        _this4.fetchVariations();
                        _this4.$emit("updateSuccess");
                        _this4.visible = false;
                      case 9:
                        _context6.prev = 9;
                        _this4.loading = false;
                        return _context6.finish(9);
                      case 12:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6, null, [[3,, 9, 12]]);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    handleSubmitEdit: function () {
      var _handleSubmitEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9() {
        var _this5 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this.$refs["form"].validate(/*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8(valid) {
                  var foodVariation;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!valid) {
                          _context8.next = 12;
                          break;
                        }
                        _this5.loading = true;
                        foodVariation = (0, _objectSpread2.default)({}, _this5.form);
                        _context8.prev = 3;
                        _context8.next = 6;
                        return (0, _foodVariation.patchVariant)(_this5.form.id, {
                          foodVariation: foodVariation,
                          foodId: _this5.food.id
                        });
                      case 6:
                        _this5.fetchVariations();
                        _this5.$emit("updateSuccess");
                        _this5.visible = false;
                      case 9:
                        _context8.prev = 9;
                        _this5.loading = false;
                        return _context8.finish(9);
                      case 12:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8, null, [[3,, 9, 12]]);
                }));
                return function (_x4) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleSubmitEdit() {
        return _handleSubmitEdit.apply(this, arguments);
      }
      return handleSubmitEdit;
    }()
  }
};